import React from 'react';

import { Flex, Space, Tag } from 'antd-v5';
import { Heading, Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

import type {
  CounselorMeritBadge,
  MeritBadge,
  MeritBadgeCounselorProfile,
} from '@appTypes/esb';
import { PersonAvatar } from '@shared/components';
import { getPreferredName } from '@shared/utils/preferredName';

import styles from './CounselorInformation.module.scss';

export default function CounselorInformation(props: {
  mbcProfile: MeritBadgeCounselorProfile;
  counselorMB: CounselorMeritBadge;
  meritBadge: MeritBadge;
}) {
  const { mbcProfile } = props;

  const counselorName = getPreferredName(props.mbcProfile);
  const mbcPicture = mbcProfile.profilePicture;
  const mbcGender = mbcProfile.gender;

  return (
    <Flex vertical gap={16} className={styles.mbcProfileCard} align="center">
      <PersonAvatar
        pictureUrl={mbcPicture}
        isAdult
        gender={mbcGender}
        className={styles.mbcImg}
      />
      <Space direction="vertical" size={8} align="center">
        <Heading color="color-primary-scoutingWarmGray" font="display-h4">
          {counselorName}
        </Heading>
        <Tag
          className={styles.mbcTag}
          bordered={false}
          color={cssVars['color-programs-SBSA-olive']}
        >
          <Text color="color-white" font="body-overline">
            MB COUNSELOR
          </Text>
        </Tag>
      </Space>
      <Space direction="vertical" size={0} align="center">
        <Text font="body-overline" color="color-text-light">
          ID
        </Text>
        <Text strong font="body-body-3" color="color-text-regular">
          {mbcProfile.memberId}
        </Text>
      </Space>
      <Text font="body-overline" color="color-text-light">
        {[mbcProfile.state, mbcProfile.city, mbcProfile.zipCode].join(', ')}
      </Text>
    </Flex>
  );
}
